import React, { useState } from "react";
import { Link } from "react-router-dom";
import { signupUser } from "../services/auth";

export default function Signup() {
  const [form, setForm] = useState({ name: "", email: "", phone: "", password: "" });
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [showPass, setShowPass] = useState(false);
  const [done, setDone] = useState(false);

  const validate = () => {
    const e = {};
    if (!form.name.trim()) e.name = "Full name is required.";
    if (!form.email.trim()) e.email = "Email is required.";
    else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(form.email)) e.email = "Enter a valid email.";
    if (form.phone && !/^\+?[\d\s\-()]{7,15}$/.test(form.phone)) e.phone = "Enter a valid phone number.";
    if (!form.password) e.password = "Password is required.";
    else if (form.password.length < 8) e.password = "Password must be at least 8 characters.";
    return e;
  };

  const handleChange = (e) => {
    setForm((f) => ({ ...f, [e.target.name]: e.target.value }));
    setErrors((er) => ({ ...er, [e.target.name]: undefined }));
  };

const handleSubmit = async (e) => {
  e.preventDefault();

  const errs = validate();

  if (Object.keys(errs).length) {
    setErrors(errs);
    return;
  }

  setLoading(true);

  try {
    const res = await signupUser(form);

    if (res.success) {
      setDone(true);

      setForm({
        name: "",
        email: "",
        phone: "",
        password: "",
      });
    } else {
      alert(res.message || "Signup failed");
    }
  } catch (error) {
    console.error(error);
    alert("Something went wrong");
  }

  setLoading(false);
};


  const strength = (() => {
    const p = form.password;
    if (!p) return 0;
    let s = 0;
    if (p.length >= 8) s++;
    if (/[A-Z]/.test(p)) s++;
    if (/[0-9]/.test(p)) s++;
    if (/[^A-Za-z0-9]/.test(p)) s++;
    return s;
  })();

  const strengthLabel = ["", "Weak", "Fair", "Good", "Strong"][strength];
  const strengthColor = ["", "#c0392b", "#e67e22", "#27ae60", "#1b4332"][strength];

  return (
    <>
      <style>{css}</style>

      <div className="auth-page">
        <div className="auth-bg" aria-hidden="true" />

        <div className="auth-card">
          <div className="auth-logo">
            <span className="auth-logo__icon">🌿</span>
            <span className="auth-logo__text">Sanjivani Ayurveda</span>
          </div>

          {done ? (
            <div className="auth-success">
              <span className="auth-success__icon">✅</span>
              <h2 className="auth-title" style={{ marginBottom: 8 }}>Account Created!</h2>
              <p className="auth-subtitle" style={{ marginBottom: 24 }}>
                Welcome to the Sanjivani family. Your wellness journey begins now.
              </p>
              <Link to="/login" className="btn-primary" style={{ textDecoration: "none", display: "inline-flex" }}>
                Sign In Now ✦
              </Link>
            </div>
          ) : (
            <>
              <h1 className="auth-title">Create Account</h1>
              <p className="auth-subtitle">Join 50,000+ people on a natural wellness journey</p>

              <form onSubmit={handleSubmit} noValidate>

                <div className="form-group">
                  <label className="form-label" htmlFor="name">Full Name <span className="form-required">*</span></label>
                  <input
                    id="name" name="name" type="text"
                    className={`form-input${errors.name ? " form-input--error" : ""}`}
                    placeholder="Your full name"
                    value={form.name} onChange={handleChange}
                    autoComplete="name"
                  />
                  {errors.name && <span className="form-error">{errors.name}</span>}
                </div>

                <div className="form-group">
                  <label className="form-label" htmlFor="email">Email Address <span className="form-required">*</span></label>
                  <input
                    id="email" name="email" type="email"
                    className={`form-input${errors.email ? " form-input--error" : ""}`}
                    placeholder="you@example.com"
                    value={form.email} onChange={handleChange}
                    autoComplete="email"
                  />
                  {errors.email && <span className="form-error">{errors.email}</span>}
                </div>

                <div className="form-group">
                  <label className="form-label" htmlFor="phone">Phone Number</label>
                  <input
                    id="phone" name="phone" type="tel"
                    className={`form-input${errors.phone ? " form-input--error" : ""}`}
                    placeholder="+91 98765 43210"
                    value={form.phone} onChange={handleChange}
                    autoComplete="tel"
                  />
                  {errors.phone && <span className="form-error">{errors.phone}</span>}
                </div>

                <div className="form-group">
                  <label className="form-label" htmlFor="password">Password <span className="form-required">*</span></label>
                  <div className="auth-pass-wrap">
                    <input
                      id="password" name="password"
                      type={showPass ? "text" : "password"}
                      className={`form-input auth-pass-input${errors.password ? " form-input--error" : ""}`}
                      placeholder="Min. 8 characters"
                      value={form.password} onChange={handleChange}
                      autoComplete="new-password"
                    />
                    <button
                      type="button" className="auth-eye"
                      aria-label={showPass ? "Hide password" : "Show password"}
                      onClick={() => setShowPass((s) => !s)}
                    >
                      {showPass ? "🙈" : "👁️"}
                    </button>
                  </div>
                  {errors.password && <span className="form-error">{errors.password}</span>}
                  {form.password && (
                    <div className="strength-wrap">
                      <div className="strength-bar">
                        {[1, 2, 3, 4].map((s) => (
                          <div
                            key={s}
                            className="strength-seg"
                            style={{ background: strength >= s ? strengthColor : "var(--c-border)" }}
                          />
                        ))}
                      </div>
                      <span className="strength-label" style={{ color: strengthColor }}>{strengthLabel}</span>
                    </div>
                  )}
                </div>

                <button type="submit" className="btn-primary auth-submit" disabled={loading}>
                  {loading ? <span className="auth-spinner" /> : "Create Account ✦"}
                </button>
              </form>

              <p className="auth-switch">
                Already have an account?{" "}
                <Link to="/login" className="auth-link">Sign In</Link>
              </p>
            </>
          )}
        </div>
      </div>
    </>
  );
}

const css = `
@import url('https://fonts.googleapis.com/css2?family=Cormorant+Garamond:ital,wght@0,400;0,600;1,400&family=Jost:wght@300;400;500;600&display=swap');

:root {
  --c-primary:       #2d6a4f;
  --c-primary-light: #40916c;
  --c-primary-dark:  #1b4332;
  --c-accent:        #d4a017;
  --c-bg:            #f9f6f0;
  --c-surface:       #ffffff;
  --c-text:          #1c2b22;
  --c-muted:         #5a7262;
  --c-border:        #d4e6d5;
  --c-error:         #c0392b;
  --f-display:       'Cormorant Garamond', Georgia, serif;
  --f-body:          'Jost', sans-serif;
  --radius:          14px;
  --shadow:          0 4px 24px rgba(27,67,50,.09);
  --shadow-lg:       0 12px 40px rgba(27,67,50,.15);
  --ease:            cubic-bezier(.4,0,.2,1);
}

*, *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; }
body { font-family: var(--f-body); background: var(--c-bg); color: var(--c-text); }

.auth-page {
  min-height: 100vh;
  display: flex; align-items: center; justify-content: center;
  padding: 90px 20px;
  position: relative;
}

.auth-bg {
  position: fixed; inset: 0; z-index: 0;
  background:
    linear-gradient(135deg, var(--c-primary-dark) 0%, #1e4d35 40%, var(--c-bg) 100%);
  opacity: .08;
}

.auth-card {
  position: relative; z-index: 1;
  background: var(--c-surface);
  border: 1px solid var(--c-border);
  border-radius: 20px;
  padding: 44px 40px;
  width: 100%; max-width: 440px;
  box-shadow: var(--shadow-lg);
  animation: authIn .45s var(--ease) both;
}

@keyframes authIn {
  from { opacity:0; transform: translateY(22px); }
  to   { opacity:1; transform: none; }
}

.auth-logo {
  display: flex; align-items: center; gap: 10px;
  justify-content: center; margin-bottom: 28px;
}
.auth-logo__icon { font-size: 1.8rem; }
.auth-logo__text {
  font-family: var(--f-display); font-size: 1.2rem; font-weight: 600;
  color: var(--c-primary-dark);
}

.auth-title {
  font-family: var(--f-display); font-size: 2rem; font-weight: 600;
  color: var(--c-primary-dark); text-align: center; margin-bottom: 6px;
}
.auth-subtitle {
  font-size: .88rem; color: var(--c-muted); text-align: center;
  margin-bottom: 28px;
}

.form-group { display: flex; flex-direction: column; margin-bottom: 16px; }
.form-label {
  font-size: .78rem; font-weight: 600; letter-spacing: .07em;
  text-transform: uppercase; color: var(--c-muted); margin-bottom: 7px;
}
.form-required { color: var(--c-error); }
.form-input {
  font-family: var(--f-body); font-size: .9rem;
  padding: 11px 16px; border-radius: 10px;
  border: 1.5px solid var(--c-border);
  background: var(--c-bg); color: var(--c-text);
  outline: none; transition: border-color .22s, box-shadow .22s; width: 100%;
}
.form-input:focus { border-color: var(--c-primary-light); box-shadow: 0 0 0 3px rgba(64,145,108,.15); }
.form-input::placeholder { color: var(--c-muted); }
.form-input--error { border-color: var(--c-error); }
.form-error { font-size: .74rem; color: var(--c-error); margin-top: 5px; }

.auth-pass-wrap { position: relative; display: flex; align-items: center; }
.auth-pass-input { padding-right: 44px; }
.auth-eye {
  position: absolute; right: 12px;
  background: none; border: none; cursor: pointer; font-size: 1rem;
  line-height: 1; padding: 4px; border-radius: 4px;
  transition: opacity .2s;
}
.auth-eye:hover { opacity: .7; }

.strength-wrap { display: flex; align-items: center; gap: 10px; margin-top: 8px; }
.strength-bar { display: flex; gap: 5px; flex: 1; }
.strength-seg { height: 4px; flex: 1; border-radius: 2px; transition: background .3s; }
.strength-label { font-size: .72rem; font-weight: 600; min-width: 38px; }

.btn-primary {
  display: inline-flex; align-items: center; justify-content: center; gap: 8px;
  font-family: var(--f-body); font-size: .82rem; font-weight: 600;
  letter-spacing: .07em; text-transform: uppercase;
  padding: 12px 28px; border-radius: 100px; border: none;
  background: var(--c-primary); color: #fff; cursor: pointer;
  transition: background .22s, transform .22s;
}
.btn-primary:hover:not(:disabled) { background: var(--c-primary-dark); transform: translateY(-1px); }
.btn-primary:disabled { opacity: .7; cursor: not-allowed; }

.auth-submit { width: 100%; margin-top: 6px; }

.auth-spinner {
  width: 18px; height: 18px; border-radius: 50%;
  border: 2px solid rgba(255,255,255,.3);
  border-top-color: #fff;
  animation: spin .7s linear infinite;
  display: inline-block;
}
@keyframes spin { to { transform: rotate(360deg); } }

.auth-switch {
  text-align: center; margin-top: 22px;
  font-size: .88rem; color: var(--c-muted);
}
.auth-link {
  color: var(--c-primary); font-weight: 600; text-decoration: none;
  transition: color .2s;
}
.auth-link:hover { color: var(--c-primary-dark); }

.auth-success { text-align: center; padding: 10px 0; }
.auth-success__icon { font-size: 3rem; display: block; margin-bottom: 16px; }

@media (max-width: 480px) {
  .auth-card { padding: 30px 22px; }
}
`;
